import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import QuestionAnswerComponent, {Question} from "../../../../components/help/QuestionAnswerComponent.tsx";

const questions: Question[] = [
    {
        question: <>Hvad betyder &ldquo;omdeling&rdquo;?</>,
        answer: <p>Omdeling betyder, at pakken bliver sendt til døren &ndash; <strong>ikke</strong> til en pakkeshop.</p>
    },
    {
        question: "Skal jeg selv betale for at sende udstyret?",
        answer: <p>Ja, jf. vores aftalevilkår skal du selv betale for at sende udstyret.</p>
    },
    {
        question: "Hvor lang tid har jeg til at sende udstyret retur?",
        answer: <>
            <p>
                Når dit internet lukker, har du 34 dage til at sende udstyret til os.
                Du får en mail med info om, at du skal sende udstyret til os. I mailen kan du se datoen, vi senest skal modtage udstyret.
                Hvis vi ikke modtager udstyret inden datoen, får du en mail med et rykkergebyr på 100&nbsp;kr.
            </p>
            <p>
                Når du får rykkergebyret, har du yderligere 7 dage til at sende udstyret.
                Hvis vi ikke modtager det inden for de 7 dage, skal du betale et gebyr for ikke-returneret udstyr på 599 kr.
            </p>
        </>
    },
    {
        question: "Kan jeg aflevere udstyret personligt på adressen?",
        answer: <p>Nej, det kan du desværre ikke. Du skal sende det med omdeling til adressen.</p>
    },
    {
        question: "Jeg køber et returlabel online, hvad er jeres mail og telefonnummer?",
        answer: <p>Du kan bruge <a href={'mailto:kundeservice@hiper.dk'}>kundeservice@hiper.dk</a> og <a href={'tel:+4588772000'}>88&nbsp;77&nbsp;20&nbsp;00</a>.</p>
    },
]

export default function UdstyrReturArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <p>
                            Når du opsiger dit abonnement, skal du returnere dit udstyr for egen regning.
                        </p>
                        <p>
                            Du skal sende udstyret <strong>med omdeling</strong>, dvs. med levering til døren &ndash; <strong>ikke</strong> pakkeshop.
                        </p>
                    </div>
                </div>
                <div className="article">
                    <h2>Sådan sender du udstyret</h2>
                    <ul className="big-steps">
                        <li>
                            <p>Du kan se hvilket udstyr du skal returnere i mailen &ldquo;Husk at sende dit udstyr til os&rdquo;</p>
                        </li>
                        <li>
                            <p>Saml udstyret du skal sende:</p>
                            <ul className="list list--bullet">
                                <li><p>Router</p></li>
                                <li><p>Evt. mediekonverter</p></li>
                                <li><p>Strømforsyning</p></li>
                                <li><p>Diverse kabler, adapter mm.</p></li>
                                <li><p>Hvis du har 5G-internet, skal du ikke returnere sim-kortet. Du kan blot smide det ud.</p></li>
                            </ul>
                        </li>
                        <li>
                            Vi finder din kontaktinformation ved at scanne routeren, så du behøver ikke notere det i pakken.
                        </li>
                        <li>
                            <p>Pak udstyret i en kasse med f.eks. avispapir eller bobleplast. Det behøver ikke være den originale kasse.</p>
                        </li>
                        <li>
                            <p>
                                Send udstyret <strong>med omdeling</strong> hos din post-leverandør til:
                            </p>
                            <p>
                                Hiper A/S<br/>
                                C/o: MatKon<br/>
                                Måløv Byvej 229,<br/>
                                2760 Måløv
                            </p>
                        </li>
                        <li>
                            <p>Gem kvitteringen med Track&amp;Trace/forsendelsesnummeret.</p>
                        </li>
                        <li>
                            <p>Du får en mail, når vi har modtaget udstyret.</p>
                        </li>
                    </ul>
                </div>

                <div className="article">
                    <h2>Ofte stillede spørgsmål om returnering af udstyr</h2>
                    <QuestionAnswerComponent questions={questions}/>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "mit-abonnement",
                        "article": "fortrydelsesret",
                        "name": "Fortrydelsesret"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "opsigelse",
                        "name": "Opsigelse af abonnement"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "bindingsperiode",
                        "name": "Bindingsperiode"
                    }
                ]}
            />
        </>
    )
}
